<template>
  <a-dropdown>
    <span class="action global-lang">
      <a-icon type="global"/>
    </span>
    <a-menu slot="overlay" style="width: 150px;" @click="SwitchLang">
      <a-menu-item key="zh_CN">
        <a rel="noopener noreferrer">
          <span role="img" aria-label="简体中文">🇨🇳</span> 简体中文
        </a>
      </a-menu-item>
      <a-menu-item key="en_US">
        <a rel="noopener noreferrer">
          <span role="img" aria-label="English">🇬🇧</span> English
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
export default {
  name: 'LangSelect',
  data () {
    return {}
  },
  methods: {
    SwitchLang (row) {
      this.$store.dispatch('SetLang', row.key)
      this.$message.success(this.$t('app.switchlang.success'))
    }
  }
}
</script>

<style lang="less" scoped>
  .ant-dropdown-menu{
    background: #303030;
    .ant-dropdown-menu-item{
      a {
        color: #fff !important;
      }
      i{
        margin-right: 8px;
      }
    }
    .ant-dropdown-menu-item-active {
      background: #464646;
      a {
        color: #4977FC !important;
      }
    }
  }
</style>
